export const MINIMUM_REQUIRED_PHOTOS = 5;
export const TOAST_DURATION = 5000;
export const CLOUDINARY_IMAGE_TRANSFORMATION = 'c_crop,g_custom/';
